import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import { c as classNames } from '../theme-provider/index-chunk.esm.js';
import { a as EGDSButton } from '../paging-button/index-chunk.esm.js';

class EGDSPrimaryButton extends React.Component {
    static displayName = 'EGDSPrimaryButton';
    render() {
        const { inverse, ...props } = this.props;
        const cssClassNames = classNames(`${EGDSButton.baseClassName}-primary`, {
            [`${EGDSButton.baseClassName}-primary-inverse`]: inverse,
        }, props.className);
        return jsx(EGDSButton, { ...props, className: cssClassNames });
    }
}

export { EGDSPrimaryButton as E };
//# sourceMappingURL=index-chunk.esm.js.map
